/**
 * Vista core.v_my_due_tasks · tareas vencidas/por vencer del user actual.
 *
 * Cast `as any` porque la vista no está en `Database['core']['Views']` —
 * mantener Views vacío para no romper queries no tipadas como prospect_documents.
 * Patrón ya usado para v_employee_directory.
 */
import { supabase } from '@/lib/supabase';
import type { MyDueTasksRow } from '@/types/database.types';

export async function listMyDueTasks(): Promise<MyDueTasksRow[]> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase as any)
    .from('v_my_due_tasks')
    .select('*')
    .order('minutes_until_due', { ascending: true })
    .limit(50);
  if (error) throw error;
  return (data ?? []) as MyDueTasksRow[];
}
